var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKaiserPermanenteLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158.4 17.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#006ba6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1rgb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.82,5.33a2.32,2.32,0,0,0-.73-.43l-.41,8.35,2.08-5.77A2.2,2.2,0,0,0,11.82,5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.39,4.83l1.22,8.34L10.8,4.83A3.48,3.48,0,0,0,8.39,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.38,5.32a2.21,2.21,0,0,0-.94,2.15l2.08,5.77L8.11,4.89A2.32,2.32,0,0,0,7.38,5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.2,6.11c1.38,2.43,2.8,5,4.18,7.37-.49-2-1-5.43-1.7-6.38A3,3,0,0,0,3.2,6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.74,7.33l5.67,6.58L2.9,6.15A2.71,2.71,0,0,0,.74,7.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.61,9.11l-.94,4.51c1.21-2.11,2.41-4.18,3.58-6.29A2.68,2.68,0,0,0,12.61,9.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.59,7.33l-3,6.68,5.26-5.75A3.08,3.08,0,0,0,15.59,7.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,10.31c1.85,1.43,3.68,2.89,5.54,4.31l-5-7.06A5,5,0,0,0,0,10.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.5,9.09a2,2,0,0,0-.44-.61L13.53,14.7c1.8-1.34,3.54-2.71,5.27-4.08A3,3,0,0,0,18.5,9.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,13.18l4.83,2.23c-1.6-1.6-3.22-3.15-4.83-4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.8,13.35V11.07L14.24,15.5C15.79,14.79,17.22,14.09,18.8,13.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,15.4c1.45.32,3,.73,4.35,1L0,13.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.8,15.53V13.78c-1.37.87-2.78,1.77-4.05,2.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0.01 17.58 4.26 17.58 0.01 15.76 0.01 17.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.8,17.58V15.92c-1.4.6-2.61,1.1-3.93,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.33,5.12a1.82,1.82,0,1,0-3.63,0C13.67,7.45,17.42,7.58,17.33,5.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.33,5.11a.07.07,0,0,1,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.19,3.8c.12-2.56-3.84-2.46-3.69,0C1.36,6.34,5.43,6.38,5.19,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.61,4.29a2,2,0,0,0,2.1-2.06A2,2,0,0,0,9.62,0,2,2,0,0,0,7.55,2.24,1.94,1.94,0,0,0,9.61,4.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.88,
    y: 7.47,
    width: 1.73,
    height: 10.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.75,7.47,31.82,16,29,12.36l3.81-4.88h-2l-3.54,4.75V7.47H25.51v10h1.73V12.55l3.66,4.94H33l.93-2.89h3.67l1,2.88h1.81l-3.45-10Zm-.4,5.73,1.33-4.15h0l1.38,4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.68,14.72,96.95,7.47h-3v10h1.7V8.94l2.2,8.53h1.73S101.73,9,101.73,9v8.52h1.68v-10h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.76,7.46l-3.46,10H106l.93-2.89h3.67l1,2.89h1.81l-3.47-10Zm-.4,5.73L108.69,9h0l1.39,4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.37,15.19l-4-7.73h-2.28v10h1.63V9.93l3.92,7.54H122v-10h-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.11,16H149V13.19h3V11.74h-3V8.91h3.76V7.46H147.3v10h5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.37,7.46h-.31v7.81l-4-7.81H130.8V16h-5.25V13.19h3V11.74h-3V8.91h3.76V7.46h-5.47v10h8.6V9.85l3.92,7.62h2.36V9h3v8.5h1.74V9h3V7.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.42,12.44a2.79,2.79,0,0,0,1-2.13,2.74,2.74,0,0,0-.93-2.12,4.18,4.18,0,0,0-2.9-.73h-2.9v4.23h0V16H80.35V13.19h3V11.74h-3V8.91h3.76V7.46H78.64v10h8.73V13.22h.86c.79,1.25,2.48,4.27,2.48,4.27h2.06l-2.69-4.41A2.92,2.92,0,0,0,91.42,12.44Zm-4-.68V8.93h1.46c1.31,0,1.84.52,1.84,1.39s-.52,1.43-1.84,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.15,12.44a2.79,2.79,0,0,0,1-2.13,2.74,2.74,0,0,0-.93-2.12,4.17,4.17,0,0,0-2.9-.73h-2.9v4.23h0V16H53.08V13.19h3V11.74h-3V8.91h3.76V7.46H51.36v10H60.1V13.22H61c.79,1.25,2.48,4.27,2.48,4.27H65.5l-2.69-4.41A2.92,2.92,0,0,0,64.15,12.44Zm-4-.68V8.93h1.46c1.31,0,1.84.52,1.84,1.39s-.52,1.43-1.84,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.64,8.22a4.18,4.18,0,0,0-2.9-.75h-2.9v5.9h0v4.12h1.74V13.36h1.17a4.12,4.12,0,0,0,2.89-.78,2.9,2.9,0,0,0,.94-2.18A2.88,2.88,0,0,0,76.64,8.22ZM74,11.9H72.57v-3H74c1.3,0,1.84.58,1.84,1.46S75.27,11.9,74,11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.66,11.64c-1.36-.5-2-.88-2-1.67,0-.6.61-1.29,1.81-1.29a5,5,0,0,1,2.16.52V7.77A5.27,5.27,0,0,0,47.5,7.3c-2.14,0-3.62,1.21-3.62,2.84,0,1.45,1.11,2.32,2.79,2.9,1.3.46,1.86.92,1.86,1.7s-.72,1.44-1.91,1.44a5.56,5.56,0,0,1-2.73-.73V17a6,6,0,0,0,2.61.59c2.59,0,3.81-1.39,3.81-3S49.41,12.29,47.66,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.7,15.71a1.65,1.65,0,1,1,1.65,1.69A1.64,1.64,0,0,1,154.7,15.71Zm1.65,2a2,2,0,1,0-2.06-2A2,2,0,0,0,156.35,17.74Zm-.43-1.87h.41l.62,1h.4l-.67-1a.61.61,0,0,0,.61-.64c0-.46-.27-.66-.83-.66h-.89v2.34h.35Zm0-.3v-.72h.48c.25,0,.51.05.51.34s-.27.38-.57.38Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaiserPermanenteLogo);
export default __webpack_public_path__ + "static/media/KaiserPermanenteLogo.b9e78dd932eedcf187540fe72e598196.svg";
export { ForwardRef as ReactComponent };